export const defaultGISProfileWidgets = [
	{
		enabled: true,
		id: "details",
		index: 0
	}
];
